import { forwardRef } from 'react';
import { ViewProps } from './ViewProps';
import { useViewProps } from './useViewProps';
import { withStopPropagation } from './withStopPropagation';

export const View = forwardRef<HTMLDivElement, ViewProps>(function ViewWithRef(props, ref) {
  const { stopPropagation, ...restProps } = props;
  const { children, testID, onClick, onPointerDown, ...rest } = useViewProps(restProps);

  return (
    <div
      ref={ref}
      data-testid={testID}
      {...rest}
      onClick={withStopPropagation(onClick, stopPropagation)}
      onPointerDown={withStopPropagation(onPointerDown, stopPropagation)}
    >
      {children}
    </div>
  );
});
